var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools01-abtest-report"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ABテストレポート")])])],1),_c('AbTestReportList',{attrs:{"toolId":_vm.toolId,"toolPageId":_vm.toolPageId,"toolPageTestId":_vm.toolPageTestId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }